{
    "translation": {
        "invoices": {
            "note": "Kære kunde, hvis du betaler med kort, bedes du se bort fra denne faktura."
        },
        "flowPicker": {
            "title": "Er du en ny eller eksisterende Flex-kunde?",
            "newCustomer": "Jeg vil gerne blive Flex-kunde",
            "existingCustomer": "Jeg er allerede flexkunde",
            "nextButton": "Gå videre"
        },
        "lisaAnd": {
            "plans": {
                "selectSubscription": "Vælg periode",
                "description": "",
                "VALUE": {
                    "title": "Flex 24 måneder",
                    "description": "Skift eller afslut efter 24 mdr"
                },
                "FLEX": {
                    "title": "Fuld fleksibilitet",
                    "description": "Skift eller afslut når du vil",
                    "priceDescription": "i {{months}} mdr, derefter {{price}}"
                },
                "disclaimer": "Prisen gælder ved godkendt bytte i angivet stand",
                "welcomeMessage": {
                    "title": "",
                    "paragraphs": [
                        "Samsung Flex er et samarbejde mellem Samsung og Lisa&, som betyder, at du har mulighed for at leje Samsung-produkter fra Lisa&. Særlige vilkår for hhv. Samsung Flex fra Samsung og Lisa& gælder."
                    ]
                }
            },
            "cart": {
                "priceFor": "{{price}} \nfor {{months}} months",
                "monthlyCost": "Din månedlige omkostning",
                "accessories": "Tilbehør",
                "prepayToday": "Beløb til betaling i dag",
                "prepayTodayDisclaimer": "{{months}} måned + Tilbehør",
                "showDiscount": "Vis rabatdetaljer",
                "VALUE": {
                    "planName": "med Flex 24 måneder"
                },
                "FLEX": {
                    "planName": "med Fuld fleksibilitet"
                },
                "totalMonthlyDiscount": "<0>Samlet månedlig rabat (1-{{months}}) <1></1></0>",
                "totalMonthlyDiscountIncludesBoth": "<0>Inkluderer din foreløbige værdi for Trade in og dine rabatter.</0>"
            }
        },
        "general": {
            "readMore": "Læs mere her",
            "images_zero": "",
            "images_one": "1 billede",
            "images_other": "{{count}} billeder",
            "edit": "Redigere",
            "cancel": "Annuller",
            "save": "Gem",
            "close": "Lukke",
            "view": "Vis og administrer",
            "back": "Tilbage",
            "errors": {
                "required": "Dette felt er påkrævet"
            }
        },
        "svea": {
            "genericDiscount": "Rabat",
            "tradeinSubsidy": "Opdateret indbytteværdi efter Foxway-certificeret gradering",
            "tradeinSubsidyPlaceholderReversal": "Bytterabat justering",
            "tradeinName": "Bytterabat",
            "upfrontPaymentProduct": "Forudbetalt: ",
            "upfrontPaymentProductDiscount": "Forudbetalt: ",
            "upfrontPaymentTradeInDiscount": "Forudbetalt: ",
            "reversal": "Annullering: "
        },
        "header": {
            "back": "Tilbage",
            "backLink": "https://shop.samsung.com/dk/cart",
            "help": "Hvis du har spørgsmål, ring 701 404 24",
            "helpLink": "Mobil: 701 404 24",
            "toggleLabel": "Menu",
            "home": "Forside",
            "login": "Log ind på din Samsung Flex-konto",
            "loginSubtitle": "Vælg login-metode",
            "loginButton": "Log ind",
            "logOut": "Log ud",
            "subscriptions": "Mine enheder",
            "invoices": "Fakturaer",
            "offers": "Tilbud",
            "account": "Min konto",
            "language": {
                "options": {
                    "fi-FI": "Finnish",
                    "sv-SE": "Swedish",
                    "no-NO": "Norwegian",
                    "nb-NO": "Norwegian",
                    "da-DK": "Danish"
                },
                "label": "Vælg sprog",
                "labelDescription": "Vælg sprog for at fortsætte",
                "selectLabel": "Sprogvælger"
            }
        },
        "banner": {
            "title": "Den nye måde at have en Samsung Galaxy på",
            "subTitle": "Passion for teknologi – med omtanke"
        },
        "footer": {
            "language": "",
            "languageLink": "",
            "backToTop": "Tilbage til begyndelsen",
            "topNote": {
                "text": "For spørgsmål om programmet eller at tale med kundeservice, venligst kontakt Samsung på 701 404 24.",
                "button": {
                    "text": "Ring kundesupport 701 404 24",
                    "url": "tel:701 404 24"
                }
            },
            "copyright": "Copyright© 1995-{{currentYear}} Samsung. Alle rettigheder forbeholdes.",
            "termsAndConditions": "<1>Se vilkår og betingelser</1>",
            "termsAndConditionsLink": "https://resellers.foxway.com/subscriptionterms-dk",
            "social": {
                "title": "Følg os på",
                "items": []
            },
            "terms": [],
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "701 404 24",
                            "url": "tel:701 404 24"
                        },
                        {
                            "text": "Mandag til fredag | 08:00 - 21:00"
                        },
                        {
                            "text": "Lørdag | Lukket"
                        },
                        {
                            "text": "Søndag | Lukket"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/dk/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& giver privatpersoner mulighed for at leje produkter, som Samsung Electronics Nordic AB stiller til rådighed inden for rammerne af Samsung Flex. I forbindelse med bestillingen kan kunden også købe visse andre produkter af Lisa&.",
                    "links": [
                        {
                            "text": "For mere information, se: https://www.samsung.com/dk/flex",
                            "url": "https://www.samsung.com/dk/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Firmanavn: Lisa & friends AB\nCVR-nummer: 559315-0955Postadresse: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nMomsregistreringsnummer: SE559315095501\n"
                },
                {
                    "title": "Om Samsung",
                    "text": "Firmanavn: Samsung Electronics Nordic AB\nOrganisationsnummer: 556445-4345\nKontaktinformation: https://www.samsung.com/dk/support/contact/\nVirksomhedsadresse: World Trade Center, 2750 Ballerup, Danmark\nPostadresse: Box 1235, 164 28 Kista, Sweden\nMomsregistreringsnummer: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "portalFooter": {
            "backToTop": "Tilbage til begyndelsen",
            "copyright": "Kundeportalen og tilhørende tjenester inden for Samsung Flex leveres af Foxway. Copyright© 1995-{{currentYear}} Samsung. Alle rettigheder forbeholdes.",
            "items": [
                {
                    "title": "Support",
                    "links": [
                        {
                            "text": "701 404 24",
                            "url": "tel:701 404 24"
                        },
                        {
                            "text": "Mandag til fredag | 08:00 - 21:00"
                        },
                        {
                            "text": "Lørdag | Lukket"
                        },
                        {
                            "text": "Søndag | Lukket"
                        },
                        {
                            "text": "Samsung Support",
                            "url": "https://www.samsung.com/dk/support/contact/#contactinfo"
                        }
                    ]
                },
                {
                    "title": "Om Samsung Flex",
                    "text": "Lisa& giver privatpersoner mulighed for at leje produkter, som Samsung Electronics Nordic AB stiller til rådighed inden for rammerne af Samsung Flex. I forbindelse med bestillingen kan kunden også købe visse andre produkter af Lisa&.",
                    "links": [
                        {
                            "text": "For mere information, se: https://www.samsung.com/dk/flex",
                            "url": "https://www.samsung.com/dk/flex",
                            "target": "_blank"
                        }
                    ]
                },
                {
                    "title": "Om Lisa&",
                    "text": "Firmanavn: Lisa & friends AB\nCVR-nummer: 559315-0955Postadresse: c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sweden\nMomsregistreringsnummer: SE559315095501"
                },
                {
                    "title": "Om Samsung",
                    "text": "Firmanavn: Samsung Electronics Nordic AB\nOrganisationsnummer: 556445-4345\nKontaktinformation: https://www.samsung.com/dk/support/contact/\nVirksomhedsadresse: World Trade Center, 2750 Ballerup, Danmark\nPostadresse: Box 1235, 164 28 Kista, Sweden\nMomsregistreringsnummer: SE5564454345-01",
                    "links": []
                }
            ]
        },
        "plans": {
            "tradeInTitle": "Yderligere rabat efter indbytning:",
            "tradeIn": "{{amount}} / md i {{duration}} md",
            "closeModal": "Lukke",
            "selectSubscription": "Samsung Flex – den nye måde at have en Samsung Galaxy på",
            "description": "Med Samsung Flex kan du have en Samsung Galaxy uden at eje den – altid til en fast pris hver måned. Du kan har frihed til at udskifte, opgradere og opsige, når du vil – eller du kan vælge en 24 måneders aftale med en 6 måneders minimumsbindingsperiode til en lavere pris. Når du opgraderer eller opsiger, får din Samsung Galaxy nyt liv eller bliver genanvendt. Flex er et samarbejde mellem Samsung og Lisa&, som giver dig mulighed for at leje enheder af Lisa&.",
            "plans": {
                "EMPTY": {
                    "title": "-",
                    "description": "",
                    "descriptionOne": "",
                    "descriptionTwo": "",
                    "descriptionThree": ""
                },
                "FLEX": {
                    "title": "Fuld fleksibilitet",
                    "description": "",
                    "descriptionOne": {
                        "title": "Byt, opgrader og afslut, når du vil",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Adgang til swap-service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "En fast månedlig pris",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "Fuld flexibilitet",
                        "paragraphs": [
                            {
                                "title": "Samsung Galaxy til en fast månedlig pris",
                                "content": "For en fast månedlig pris får du adgang til din ønskede Samsung Galaxy så længe du vil have den."
                            },
                            {
                                "title": "Udskift eller opgrader, når du vil",
                                "content": "Det er nemt at udskifte eller opgradere med Fuld Fleksibilitet. Start med at bestille din nye Samsung Galaxy på samsung.com. Din nye enhed leveres hjem til dig sammen med en returfragtseddel til den gamle enhed. \nDu behøver altså ikke at undvære en Samsung Galaxy."
                            },
                            {
                                "title": "Opsig, når du vil",
                                "content": "Med Fuld Fleksibilitet kan du opsige abonnementet, når du vil, og du betaler kun for resten af den måned, hvor du opsiger.\n\n Når du har valgt at opsige sender Lisa& dig en returfragtseddel, som du anvender til at returnere enheden i. Enheden skal sendes til Lisa& senest 14 dage efter, at du har modtaget din returseddel. Hvis enheden ikke returneres inden for den angivne first, betragtes opsigelsen som ugyldig, og fakturering af abonnementet fortsættes indtil enheden er modtaget af Lisa&.\n\nNår du har haft din enhed i 24 måneder, kan du også vælge at beholde den, når du opsiger abonnementet. Du skal da betale maksimalt 10 % af den ordinære salgspris, som var gældende på samsung.com, da du indgik din aftale."
                            },
                            {
                                "title": "Hvis din enhed bliver beskadiget",
                                "content": "Inden for rammerne af Samsung Flex tilbydes Swap Service. Swap Service betyder, at du i tilfælde af utilsigtede skader som følge af, at du har tabt enheden, eller vandskader, betaler et begrænset skadesgebyr for en erstatningsenhed.\n\nSkaden skal anmeldes via kundeportalen, hvorefter Lisa& vurderer, om skaden er dækket af Swap Service. Hvis skaden bliver godkendt, vil Lisa& sende dig en erstatningsenhed sammen med et returkit til den beskadigede enhed. Den beskadigede enhed skal sendes til Lisa& senest 14 dage efter, at du har modtaget erstatningsenheden.\n\nHvis din enhed bliver stjålet, forsvinder eller bliver ødelagt på en anden måde end de skader, der er dækket af Swap Service, er du forpligtet til at erstatte Lisa& for skaden. Lisa& forbeholder sig retten til at tilbyde en brugt erstatningsenhed. Du kan læse de fuldstændige vilkår på https://resellers.foxway.com/subscriptionterms-dk."
                            },
                            {
                                "title": "Giv en gammel enhed i bytte, og få rabat",
                                "content": "Som ny Samsung Flex-kunde kan du vælge at give din gamle telefon i bytte. Med Fuld Fleksibilitet fordeles bytteværdien og eventuelle yderligere rabatter over 12 måneder (eller længere, hvis rabatten overstiger 12 månedlige betalinger). Hvis du opgraderer eller udskifter din enhed, overføres rabatten til den nye enhed."
                            },
                            {
                                "title": "Tilbehør",
                                "content": "Sammen med Samsung Flex kan du købe tilbehør for maks. 3.700 kr. Tilbehør købes af vores partner Lisa&."
                            }
                        ]
                    },
                    "priceDescription": "{{basePrice}} efter {{months}} måneder"
                },
                "VALUE": {
                    "title": "24 måneder",
                    "descriptionOne": {
                        "title": "Lavere månedlig pris med aftale på 24 måneder (mindste kontraktperiode på 6 måneder)",
                        "tooltip": ""
                    },
                    "descriptionTwo": {
                        "title": "Opgrader eller returnering ved kontraktens udløb",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "title": "",
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "descriptionThree": {
                        "title": "Adgang til swap-service",
                        "tooltip": "",
                        "modal": {
                            "trigger": "",
                            "paragraphs": [
                                {
                                    "title": "",
                                    "content": ""
                                },
                                {
                                    "content": ""
                                }
                            ]
                        }
                    },
                    "accordion": {
                        "title": "24 Måneder",
                        "paragraphs": [
                            {
                                "title": "",
                                "content": "Med 24 Måneder betaler du en lavere pris for at have en Samsung Galaxy. Efter 24 måneder kan du vælge at opgradere eller opsige Samsung Flex. Hvis du opsiger, kan du returnere enheden eller beholde den mod at betale et engangsgebyr. Du kan dog altid opsige aftalen efter 5 måneder med 1 måneds opsigelsesvarsel. Hvis du før udløbet af de 24 måneder opsiger din aftale, har du dog ikke mulighed for at købe din Samsung Galaxy ud."
                            },
                            {
                                "title": "Samsung Galaxy til en fast månedlig pris",
                                "content": "For en fast månedlig pris får du adgang til den ønskede Samsung Galaxy i 24 måneder."
                            },
                            {
                                "title": "Opgrader, opsig eller behold efter 24 måneder",
                                "content": "Når udløbet af de 24 måneder nærmer sig sin afslutning, vil du blive kontaktet, så du kan træffe dit valg. Det er nemt at udskifte eller opgradere med Samsung Flex.\nStart med at bestille din nye Samsung Galaxy på samsung.com. Din nye enhed leveres hjem til dig sammen med en returseddel til den gamle enhed.\nDu behøver altså ikke at undvære en Samsung Galaxy, når du opgraderer.\n\nHvis du vælger at opsige abonnementet, bliver der kun sendt en returseddel. Enheden skal sendes til Lisa& senest 14 dage efter, at du har modtaget returseddelen. Hvis du ikke returnerer enheden til tiden eller vælger at beholde den, vil du blive opkrævet et tilbagekøbsgebyr."
                            },
                            {
                                "title": "Opsigelse før tid",
                                "content": "Hvis du vælger at opsige aftalen før tid (mindste aftaleperiode er 6 måneder), kan du først indgå en ny aftale på 24 måneder, efter at den eksisterende aftale skulle være udløbet (24 måneder fra kontraktens indgåelse). I tilfælde af opsigelse før tid gælder en opsigelsesperiode på 30 dage efter bindingsperioden, og du har ikke ret til at købe enheden."
                            },
                            {
                                "title": "Hvis din enhed bliver beskadiget",
                                "content": "Inden for rammerne af Samsung Flex tilbydes Swap Service. Swap Service betyder, at du i tilfælde af utilsigtede skader som følge af, at du har tabt enheden, eller vandskader, betaler et begrænset skadesgebyr for en erstatningsenhed.\n\nSkaden skal anmeldes via kundeportalen, hvorefter Lisa& vurderer, om skaden er dækket af Swap Service. Hvis skaden bliver godkendt, vil Lisa& sende dig en erstatningsenhed sammen med et returkit til den beskadigede enhed. Den beskadigede enhed skal sendes til Lisa& senest 14 dage efter, at du har modtaget erstatningsenheden.\n\nHvis din enhed bliver stjålet, forsvinder eller bliver ødelagt på en anden måde end de skader, der er dækket af Swap Service, er du forpligtet til at erstatte Lisa& for skaden. Lisa& forbeholder sig retten til at tilbyde en brugt erstatningsenhed. Du kan læse de fuldstændige vilkår på https://resellers.foxway.com/subscriptionterms-dk."
                            },
                            {
                                "title": "Giv en gammel enhed i bytte, og få rabat",
                                "content": "Som ny Samsung Flex-kunde kan du vælge at give din gamle telefon i bytte. For 24 Måneder fordeles bytteværdien og eventuelle yderligere rabatter over 24 måneder. Opsiger du aftalen efter bindingsperioden men før de 24 Måneder, kan du vælge at bruge den tilbageværende rabat ved leje af en ny Samsung Galaxy eller anmode om, at den resterende rabat udbetales senest 30 dage efter din Samsung Galaxy er modtaget i funktionsdygtig og skadesfri stand."
                            },
                            {
                                "title": "Tilbehør",
                                "content": "Sammen med Samsung Flex kan du købe tilbehør for maks. 3.700 kr. Tilbehør købes af vores partner Lisa&."
                            }
                        ]
                    }
                }
            },
            "selected": "Dit valg",
            "select": "Vælg",
            "minimumTotalCost": "Minimumspris\n{{cost}}"
        },
        "sign": {
            "acceptTermsLabel": "Send mig markedsføring",
            "acceptTerms": "Jeg accepterer, at Samsung Electronics Nordic AB sender mig informationer om Samsungs produkter og tjenester via email. Jeg kan tilbagekalde mit samtykke ved at klikke på afmeldingslinket i modtagne e-mails. Se informationer om behandlingen af mine personoplysninger <1>her</1>.",
            "acceptTermsLink": "https://www.samsung.com/dk/info/privacy/",
            "title": "Personlig information",
            "firstName": "Fornavn",
            "lastName": "Efternavn",
            "email": "E-mail",
            "phone": "Telefonnummer",
            "postalCode": "Postnummer",
            "address": "Adresse",
            "city": "By",
            "errors": {
                "firstName": "Ugyldigt fornavn",
                "lastName": "Ugyldigt efternavn",
                "lastNameTooBig": "Understøttelse af maksimalt 40 tegn. Fjern venligst mellemnavne og andre navne, der ikke benyttes til daglig brug.",
                "firstNameTooBig": "Understøttelse af maksimalt 40 tegn. Fjern venligst mellemnavne og andre navne, der ikke benyttes til daglig brug.",
                "email": "Ugyldig e-mail",
                "phone": "Ugyldigt telefonnummer",
                "postalCode": "Ugyldigt postnummer",
                "address": "Ugyldig adresse",
                "city": "Ugyldig by"
            },
            "steps": {
                "yourInfo": "Dine oplysninger",
                "sign": "Underskriv",
                "confirmation": "Bekræftelse"
            },
            "delivery": "Levering",
            "differentShippingAddress": "Min leveringsadresse er forskellig fra min faktureringsadresse",
            "deliveryMethods": {
                "dk-hd-parcel-postnord-mx": {
                    "name": "Gratis hjemmelevering med Postnord",
                    "description": "",
                    "cartTitle": "Gratis hjemmelevering med Postnord",
                    "price": "Gratis"
                },
                "se-sena-hd-parcel-postnord": {
                    "name": "Hemleverans med Postnord",
                    "description": "Normal leveranstid är 1-5 vardagar, men kan vara längre för vissa postnummer.",
                    "cartTitle": "Hemleverans med Postnord",
                    "price": "Kostnadsfri"
                },
                "no-sena-hd-mxparcel-bring": {
                    "name": "Levering med Bring",
                    "description": "Normal leveringstid  er 1-5 virkedager",
                    "cartTitle": "Levering med Bring",
                    "price": "Gratis"
                },
                "no-sena-hd-parcel-dhl": {
                    "name": "Hjemlevering (pakke) - DHL",
                    "description": "Leveringstid ved hjemlevering (pakke) er 1-5 arbeidsdager. \nYtterligere leveringstid til visse postnumre kan påløpe.\nTransportøren meddeler deg via SMS under transporten med \nanslått leveringsdato og tid.",
                    "cartTitle": "DHL Express hemleverans",
                    "price": "Kostnadsfri"
                },
                "no-sena-pick-up-point": {
                    "name": "Fremsending - Bring",
                    "description": "I hovedsak 1–3 virkedager avhengig av strekning.\n4–5 dager til enkelte destinasjoner. \nE-varsling (sms/e-post) uten tillegg i prisen forutsetter \nat vi har mobilnummer eller e-postadresse. ",
                    "cartTitle": "Bring pickup",
                    "price": "Kostnadsfri"
                },
                "dk-sena-hd-parcel-postnord": {
                    "name": "Levering med Postnord",
                    "description": "Levering til dören. Normal leveringstid er 1-5 hverdage.",
                    "cartTitle": "Levering med Postnord",
                    "price": "Gratis"
                },
                "fi-sena-hd-parcel-postnord": {
                    "name": "Kotiinkuljetus (paketti) – Postnord",
                    "description": "Toimitusaika 1-5 arkipäivää.\nToimitusaika saattaa olla pidempi tiettyjen postinumeroiden.\nLiikenteenharjoittajan tulee ilmoittaa sinulle tekstiviestitse \narvioitu toimituspäivä ja -aika kuljetukselle.",
                    "cartTitle": "Postnord hemleverans",
                    "price": "Kostnadsfri"
                }
            }
        },
        "validationStep": {
            "title": "Kreditvurdering",
            "subtitle": "For at vi kan behandle din ansøgning, skal vi foretage en kreditvurdering. Følg venligst nedenstående instruktioner for at fortsætte.",
            "loadingText": "Vi er i gang med kreditvurderingen, det vil tage et par minutter. Vent venligst, du vil automatisk blive omdirigeret til næste trin."
        },
        "creditCheckStep": {
            "title": "Credit check",
            "subtitle": "We need to run a credit check",
            "terms": "I accept that my information will be submitted to <1>lorem ipsum dolor sit</1> for credit check report.",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "personalNumber": "Personal number",
            "errors": {
                "personalNumber": "Invalid personal number"
            }
        },
        "authStep": {
            "title": "Log ind med MitID",
            "subtitle": "Log ind på din Flexkonto med MitID for at se dine Flex-enheder og vælge en enhed til opgradering eller tilføje en enhed, hvis du ønsker det.",
            "authenticationMethod": "Autentificeringsmetode",
            "termsLink": "https://www.foxway.com/sv/integritetspolicy/",
            "pepTerms": "Hermed bekræfter jeg, at jeg ikke er en politisk eksponeret person (PEP), og at jeg ikke er et familiemedlem eller en kendt medarbejder til en politisk eksponeret person.",
            "loginWith": "Log ind med MitID"
        },
        "existingSubscriptionStep": {
            "title": "Din(e) flex-enhed(er).",
            "description": "Vil du opgradere en eksisterende enhed eller tilføje en ny?",
            "buttonText": "Tilføj en ny Flex-enhed",
            "infoText": "",
            "flexTitle": "Fuld Fleksibilitet",
            "valueTitle": "24 måneder",
            "eligibleFrom": "Kan opgradere fra: <bold>{{date}}</bold>",
            "planMismatchDisclaimer": "Kan kun opgraderes til <bold>{{name}}</bold>",
            "activeFrom": "Aktiv fra: <bold>{{date}}</bold>",
            "upgrade": "Opgrader",
            "upgradeNotEligible": {
                "date": "Det er endnu ikke muligt at opgradere. Se datoen ovenfor for, hvornår opgradering er mulig.",
                "contactSupport": "Opgradering er ikke mulig. Kontakt venligst kundesupport.",
                "pendingUpgrade": "Dette abonnement har allerede en underskrevet opgradering.",
                "activeClaim": "Det er ikke muligt at opgradere på grund af en igangværende supportsag.",
                "deviceNotReturned": "Det er ikke muligt at opgradere. Vi venter på en anden enhed fra dig.",
                "paymentPending": "Dette abonnement har allerede en underskrevet opgradering med en afventende betaling. Du kan fortsætte her: ",
                "link": "link"
            }
        },
        "cart": {
            "disclaimer": "Indbytteværdien er et skøn. Rabatten fastsættes og tilføjes, når indbyttet er gennemført.",
            "tradeInMonthlyEstimate": "Månedlig pris efter indbytte",
            "tradeInTitle": "Samsung Trade-in",
            "tradeInValue": "Bytteverdi",
            "tradeInMonthlyDiscount": "Månedlig Trade-in rabat i {{duration}} måneder",
            "prepayToday": "At betale i dag",
            "prepay": "Betal {{months}} måned idag",
            "discountDuration": "rabat i {{months}} måneder",
            "includesDiscount": "inklusive din rabat {{discount}}",
            "cart": "Indkøbskurv",
            "overview": "Oversigt",
            "oneTimeCost": "Engangsomkostninger",
            "oneTimeCostAccessories": "Engangsomkostninger - Tilbehør",
            "seeDetailsBelow": "Se detaljer nedenfor",
            "authentication": "Bekræft",
            "reviewAndSign": "Gennemgå og underskriv",
            "continue": "Fortsæt",
            "paymentMethod": "Betalingsmetode",
            "invoice": "Faktura",
            "minimumTotalCost": "Minimumspris",
            "monthlyCost": "Din månedlige omkostning",
            "monthlyCostWithoutDiscount": "Månedlig pris før rabat",
            "generalDiscount": "Rabat",
            "specialPriceTitle": "De første {{specialPriceLength}} måneder, derefter {{priceGross}} {{currencyMonthly}}",
            "creditCheck": "Run credit check",
            "fraudProtection": "Vent venligst",
            "emptyText": "Vælg venligst din abonnementstype først.",
            "noticeText": "Ved at tilføje min betalingsmetode accepterer jeg, at Lisa& automatisk og på forhånd kan opkræve alle omkostninger, der skal betales til Lisa&."
        },
        "currency": {
            "perMonth": "mdr",
            "feeForMonths": "{{fee}} i {{months}} mdr"
        },
        "errorPages": {
            "accessory": {
                "title": "De maksimale samlede omkostninger for køb af tilbehør er overskredet.",
                "button": "Tilbage til indkøbskurven",
                "content": "<1><2>Sammen med din Samsung Flex-enhed kan du købe andre produkter for maksimalt 3.500 kr. Værdien af tilbehøret i din indkøbskurv overstiger dette beløb, og du skal derfor afgive en separat ordre med en anden betalingsmetode for tilbehøret.</2></1>"
            },
            "general": {
                "title": "Noget gik galt",
                "button": "Tilbage til indkøbskurven",
                "content": "<1><2>Noget gik galt. Prøv venligst igen</2></1>"
            },
            "auth": {
                "title": "Noget gik galt",
                "button": "Tilbage til indkøbskurven",
                "content": "<1><2>Noget gik galt. Prøv venligst igen</2></1>"
            },
            "creditCheck": {
                "title": "Kreditvurdering Ikke godkendt",
                "button": "Tilbage til indkøbskurven",
                "contentFailed": "Din ansøgning er blevet afvist, da den ikke opfylder vores finansieringspartners kriterier for dette produkt. For yderligere oplysninger er du velkommen til at kontakte vores kundesupport.",
                "contentTryAgain": "Din ansøgning er blevet afvist, da den bank eller konto du valgte ikke ser ud til at være din primære konto. Gå tilbage og ansøg med din primære bankkonto."
            }
        },
        "errors": {
            "generic": "Noget gik galt. Prøv venligst igen",
            "authenticationError": "Uautoriseret adgang",
            "nicknameChangeError": "Nickname must be between 1 and 40 characters",
            "scrive": {
                "authenticationError": "Noget gik galt med godkendelsen. Prøv igen."
            },
            "svea": {
                "general": "",
                "underAge": "",
                "overAge": "",
                "numberOfAllowedSubscriptions": ""
            }
        },
        "portal": {
            "fraudulentCustomer": "Du har ubetalte fakturaer.",
            "payingIssuesCustomer": "Du har ubetalte fakturaer.",
            "dashboard": {
                "title": "Velkommen, "
            },
            "invoiceStatus": {
                "due": "Ikke betalt",
                "allPaid": "Betalt",
                "dueOn": "Forfaldsdato:: <2>{{date}}</2>.",
                "nextPayment": "Næste faktura skal betales senest: <2>{{date}}</2>.",
                "noNextPayment": "Ingen næste betaling.",
                "button": "Vis fakturaer"
            },
            "products": {
                "nickname": "{{firstName}}s enhed"
            },
            "invoice": {
                "status": {
                    "outstanding": "Ikke betalt",
                    "partiallyPaid": "Delvist betalt",
                    "paid": "Alt er betalt!",
                    "terminated": "Afsluttet",
                    "unknown": "Ukendt",
                    "credited": "Krediteret"
                }
            },
            "invoices": {
                "title": "Fakturaer",
                "tableHeader": ["Faktura ID", "Beskrivelse", "Periode", "Forfaldsdato", "Sum", "Status"],
                "viewInvoice": "Vis faktura",
                "viewInvoices": "Se fakturaer",
                "loadMore": "Indlæs mere",
                "accordion": {
                    "title": "Hvordan tilmelder jeg PBS?",
                    "text": "Indbetaling kan foretages i din netbank eller i din bank App. Tilmelding til PBS anbefales, og kan gøres i din netbank ved brug af debitorgruppenummer 00100, kreditornummer 88346866, samt dit kundenr."
                },
                "status": {
                    "outstanding": "Ikke betalt",
                    "partiallyPaid": "Delvist betalt",
                    "paid": "Betalt",
                    "terminated": "Afsluttet",
                    "unknown": "Ukendt"
                },
                "noInvoices": "Ingen fakturaer"
            },
            "billingAlert": {
                "generic": {
                    "before": "Din betalingsmetode er ved at udløbe. ",
                    "link": "Opdater betalingsmetode",
                    "after": ""
                },
                "detailed": {
                    "before": "Din betalingsmetode er ved at udløbe. For at fortsætte med at bruge vores tjenester efter {{dueDate}} bedes du ",
                    "link": "opdatere din betalingsmetode",
                    "after": "."
                }
            }
        },
        "profile": {
            "title": "Min konto",
            "contactInformation": {
                "title": "Kontaktinformation",
                "firstName": "Fornavn",
                "lastName": "Efternavn",
                "email": "Email",
                "phone": "Telefon"
            },
            "billingInformation": {
                "title": "Faktureringsinformation",
                "card": "Kort",
                "expires": "Udløber",
                "updatePaymentMethod": "Opdater betalingsmetode",
                "methodUpdateDescription": "Opdatering af betalingsmetode",
                "noInfo": "Ingen faktureringsinformation tilgængelig"
            },
            "address": {
                "title": "Adresse",
                "postalCode": "Postnummer",
                "address": "Adresse",
                "city": "Sted",
                "saveButton": "Gem adresse"
            },
            "notificationPreferences": {
                "marketingModal": {
                    "title": "Send mig markedsføring",
                    "content": "Jeg accepterer, at Samsung Electronics Nordic AB sender mig informationer om Samsungs produkter og tjenester via email og push-besked. Jeg kan tilbagekalde mit samtykke ved at ved at ændre indstillinger i min profil. Se informationer om behandlingen af dine personoplysninger <a href=\"https://www.samsung.com/dk/info/privacy/\">her</a>"
                },
                "title": "Notifikationer",
                "marketingEmails": "Markedsføring",
                "marketingEmailsLabel": "Send mig markedsføring og specielle fordele"
            },
            "contactInformationDisclaimer": {
                "title": "Dine kontaktoplysninger",
                "card": {
                    "title": "Dine kontaktoplysninger",
                    "description": "Dine kontaktoplysninger er registreret ved afgivelse af ordre. Kontakt kundeservice, hvis du vil opdatere dine oplysninger.\n701 404 24",
                    "link": "",
                    "linkUrl": ""
                }
            }
        },
        "offers": {
            "title": "Tilbud"
        },
        "upgrade": {
            "title": "Opgradere"
        },
        "faq": {
            "title": "Frequently Asked Questions",
            "items": [
                {
                    "id": "samsung-flex",
                    "label": "What is Samsung Flex",
                    "children": "Samsung Flex is a service for you who would rather have a fixed monthly cost and regularly keep yourself updated instead of buying your Samsung Galaxy separately. Samsung Flex is available in two variants, Full Flexibility which gives you the freedom to change, upgrade or terminate whenever you want or 24 months where you pay a lower monthly cost and have your phone a little longer. Access to swap service applies to both."
                },
                {
                    "id": "samsung-flex-vs-buying",
                    "label": "How is Samsung Flex different from buying a device outright or in installments?",
                    "children": "..."
                }
            ]
        },
        "subscription": {
            "tradeInReimbursement": "Tilbagebetaling af resterende indbytningssaldo",
            "flexSubscriptionFee": "Flex-abonnementsgebyr",
            "depositAndAccessoryPayment": "Depositum og betaling af tilbehør",
            "upfrontPayment": "Betaling af {{months}} månedlige og tilbehør",
            "endedDate": "Slutdato: <1></1>",
            "upgradeFrom": "Kan opgraderes fra: <1></1>",
            "ended": "Afsluttet",
            "contractSigned": "Kontrakt underskrevet",
            "contractStarted": "Abonnementet er startet",
            "contractEnded": "Abonnementet er afsluttet",
            "upgradeAnyTime": "Opgrader, når du vil",
            "devicesTitle": "Mine tidligere enheder",
            "flexTitle": "Dine enheder med Full Flex",
            "imeiCopy": "IMEI kopieret",
            "viewContract": "Se aftale",
            "viewInvoices": "Vis fakturaer",
            "manageSubscription": "Administrer min enhed",
            "addNewSubscription": "Tilføj en ny enhed",
            "addNewSubscriptionLink": "https://shop.samsung.com/dk/",
            "swapService": "Swap Service",
            "insuranceService": "Opret forsikringssag",
            "deviceDamagedConditionTermsLink": "https://resellers.foxway.com/subscriptionterms-dk",
            "deviceDamagedConditionTerms": "<0>Hvis enheden er beskadiget eller forsvundet, skal du betale Foxway for den skade, der er forårsaget. Ved uforsætlige tabs- og vandskader betaler du et begrænset skadegebyr for at få en erstatningsenhed. Beløbet varierer afhængig af, hvilken model du har. Besvar spørgsmålene herunder for at beskrive din sag, og få Foxways bedømmelse af, om din skade kvalificerer dig til en Swap service. Hvis din skade kvalificerer dig til Swap service, sender Foxway en erstatningsenhed hjem til dig sammen med et returkit, som du skal bruge til at returnere din beskadigede enhed. Bemærk, at du skal returnere den beskadigede enhed inden for 14 dage, fra du modtog din erstatningsenhed. Hvis du ikke returnerer din beskadigede enhed, vil Foxway fakturere dig for erstatningsenheden i henhold til aftalen. Se de fuldstændige vilkår for Swap service <2>her</2></0>",
            "subscriptionsTitle": "Mine enheder",
            "valueTitle": "Dine enheder med 24 måneder",
            "nickname": {
                "title": "Redigér",
                "nickname": "Navn",
                "description": "Du kan tilføje en kort beskrivelse til en enhed, så du kan holde styr på dine enheder, hvis du har flere. Du kan give den et hvilket som helst navn, f.eks. ”Lasses”."
            },
            "payPendingPayment": "Betal",
            "pendingPaymentsTitle": "Venter",
            "tags": {
                "upgradeTo": "Opgraderer til",
                "upgradeFor": "Opgrader til",
                "beingDelivered": "Bliver leveret",
                "pendingPayemnt": "Underskrevet, men betaling afventer"
            },
            "cancel": {
                "title": "Opsigelse af Samsung Flex",
                "bolttech": {
                    "title": "Afslut Samsung Flex",
                    "deviceDamagedConditionTerms": "<0>Hvis enheden bliver beskadiget eller du mister den, skal du kompensere Lisa& for den opståede skade. Forsikringsaftalen Samsung Care+ følger med i Samsung Flex og dækker utilsigtede tab- og vandskader, for hvilke der skal oprettes en forsikringssag. Gældende for andre skader kan Samsungs garanti benyttes.</0><1>Udfyld formularen for at få hjælp til at afklare, hvordan dit problem bliver løst bedst muligt.</1>",
                    "submitButton": "Fortsæt",
                    "continueButton": "Fortsæt",
                    "fellAndBrokeNotificationTitle": "Din type skade dækkes normalt af Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Fortsæt for at oprette en forsikringssag hos forsikringsselskabet.",
                    "stoppedWorkingNotificationTitle": "Dit problem dækkes ikke af forsikringen, men er omfattet af garantien.",
                    "stoppedWorkingNotificationContent": "Kontakt vores support for mere information.",
                    "lostOrStolenNotificationTitle": "Hvis du har mistet din telefon, dækker forsikringen ikke.",
                    "lostOrStolenNotificationContent": "Kontakt vores support for mere information.",
                    "damageSpecTitle": "Upload venligst billeder, der viser enhedens stand",
                    "specificDamage": {
                        "frontScreen": "Forsiden",
                        "frontScreenDescription": "Upload billede(r), der viser enhedens forside og hovedskærm",
                        "backSide": "Bagsiden",
                        "backSideDescription": "Upload billede(r), der viser enhedens bagside"
                    }
                },
                "unavailableNotification": {
                    "title": "Opsig dit abonnement",
                    "content": "Din ordre kan ikke annulleres på nuværende tidspunkt. Kontakt vores support for mere information.",
                    "linkText": "",
                    "linkUrl": "",
                    "automaticClaim": "Din Samsung Flex-aftale udløber snart. Vi har allerede påbegyndt den automatiske opsigelse, og du bør modtage et retursæt snart. Vil du opgradere til en ny enhed? Gå til Samsung.com og bestil din nye enhed. Vælg at opgradere din eksisterende enhed under betalingen. Hvis du ønsker at beholde enheden, bedes du kontakte vores support for et tilbud på køb."
                },
                "receipt": {
                    "title": "Swap service med sags-id {{id}} er registreret",
                    "content": "Du kan se status for igangværende Swap service under Mine enheder\nNår din sag er behandlet, sendes en erstatningsenhed til dig sammen med et returkit, som du skal bruge til at returnere den beskadigede enhed til Foxway, der tager sig af den på bedste vis.\nHusk:\n1. Hvis det er muligt, skal du nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto fra den beskadigede enhed.\n2. Den beskadigede enhed skal være returneret inden for 14 dage, fra du modtager din erstatningsenhed. Hvis du ikke returnerer din enhed, kan Foxway fakturere dig for erstatningsenhedens markedsværdi.",
                    "button": "Tilbage til Startsiden"
                },
                "keepDisclaimerTitle": "Jeg vil tilbagelevere enheden",
                "keepDisclaimerContent": "Hvis du vil beholde din enhed, skal du kontakte vores support.",
                "upgradeDisclaimerLink": "Administrer dette abonnement",
                "upgradeDisclaimerTitle": "Vil du opgradere til en ny enhed?",
                "upgradeDisclaimerContent": "Hvis du vil opgradere din enhed, skal du vende tilbage til siden 'administration af abonnementer'.",
                "stateChoice": {
                    "title": "Vil du beholde, returnere eller opgradere enheden?",
                    "returnDevice": "Jeg vil tilbagelevere enheden",
                    "keepDevice": "Jeg vil beholde enheden",
                    "upgradeDevice": "Jeg vil opgradere min enhed"
                },
                "invoicesDisclaimerTitle": "Udestående fakturaer",
                "invoicesDisclaimerContent": "Du har ubetalte fakturaer, vær opmærksom på, at alle fakturaer skal betales, inden annulleringen gennemføres.",
                "errors": {
                    "frontSideDamageFiles": "Upload venligst et billede af forsiden af enheden",
                    "backSideDamageFiles": "Upload venligst et billede af bagsiden af enheden"
                },
                "claimStatus": {
                    "pending": "Annullering indsendt",
                    "approved": "Afbestilling godkendt",
                    "declined": "Annullering afvist",
                    "completed": "Annullering gennemført",
                    "sent": "Retursæt sendt",
                    "waitingForPayment": "Har udestående fakturaer",
                    "paymentReceived": "Payment received",
                    "deviceReceived": "Enhed modtaget",
                    "deviceReceivedDamaged": "Enhed modtaget beskadiget"
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vil du opsige Samsung Flex?",
                        "content": [
                            "Med Full Flex kan du til enhver tid opsige din aftale. Tjenesten afsluttes ved udløbet af den måned du opsiger aftalen i, og du betaler dermed for tjenesten måneden ud. Du får et returkit sendt hjem til dig, som du kan bruge til at returnere din enhed. Når måneden er gået, har du 14 dage til at tilbagelevere enheden.\n\nHusk:\n<ul><li> At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto fra din enhed, inden du sender den.</li><li> Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved opsigelse.</li><li> Hvis enheden er beskadiget, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du et begrænset skadegebyr.</li><li> Fakturering genoptages for din enhed, hvis den ikke er returneret inden for 14 dage, efter udløbet af den måned hvor du opsagde aftalen.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du til enhver tid opsige din aftale. Tjenesten afsluttes ved udløbet af den måned du opsiger aftalen i, og du betaler dermed for tjenesten måneden ud. Du får et returkit sendt hjem til dig, som du kan bruge til at returnere din enhed. Når måneden er gået, har du 14 dage til at tilbagelevere enheden.\n\nHusk:\n<ul><li> At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto fra din enhed, inden du sender den.</li><li> Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved opsigelse.</li><li> Enheden skal leveres tilbage i god stand - normal slitage er ok. Hvis enheden bliver beskadiget, skal du kompensere Lisa& for den opståede skade. Utilsigtede tab- og vandskader dækkes af den medfølgende forsikring, for hvilke der skal oprettes en forsikringssag. Følg instruktionerne i næste trin for at gå videre.</li><li>Fakturering genoptages for din enhed, hvis den ikke er returneret inden for 14 dage, efter udløbet af den måned hvor du opsagde aftalen.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Sådan fungerer det - trin for trin",
                        "steps": [
                            "Klik på afslut og følg vejledningen. Du skal svare på spørgsmål om din enheds stand.",
                            "Når du har afsluttet opsigelsen af tjenesten, sendes et returkit hjem til dig.",
                            "Slet alle informationer, og fjern din Googlekonto på den gamle enhed.",
                            "Pak den gamle enhed omhyggeligt, og aflever den på nærmeste posthus."
                        ],
                        "action": "Opsig tjenesten",
                        "eligibleNotificationText": "For at annullere din kontrakt i løbet af de første {{days}} dage, kontakt venligst Samsung."
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header2.png",
                        "title": "Vil du opsige Samsung Flex?",
                        "content": [
                            "Med 24 måneder kan du vælge at opsige tjenesten og sende din enhed tilbage eller opsige og betale et gebyr for at frikøbe den, hvis du ønsker at beholde den efter aftaleperioden.\nDu kan foretage dit valg, her i kundeportalen en måned inden aftaleperioden udløber. Hvis du ikke gør noget aktivt, udløber tjenesten automatisk, og du skal returnere din enhed. Når enheden skal afleveres, sender Foxway et returkit til dig, som du skal bruge til at returnere din enhed.\nHvis du ønsker at opsige før tid, har du ret til at opsige din aftale med 30 dages opsigelse med en mindste bindingstid på 6 måneder. Bemærk at du så ikke kan indgå en ny aftale på 24 måneder, før din aftale skulle være udløbet. Kontakt kundeservice, hvis du ønsker at opsige tidligt, så hjælper vi dig.\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Googlekonto</li><li> Hvis enheden er beskadiget, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du kun en begrænset selvrisiko.</li><li> Hvis din enhed ikke er returneret inden for 14 dage, efter at aftaleperioden er udløbet, bliver du faktureret et gebyr for at kompensere Foxway for den ikke tilbageleverede enhed.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med 24 måneder kan du vælge at opgradere eller afslutte tjenesten ved udløbet af aftalen. Hvis du ikke foretager et aktivt valg, afsluttes tjenesten automatisk, og du skal returnere enheden. Når enheden skal returneres, sender Foxway dig et returkit, som du bruger til at sende den tilbage. Kontakt kundeservice, hvis du ønsker at opsige aftalen før tid.\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Googlekonto</li><li>Enheden skal leveres tilbage i god stand - normal slitage er ok. Hvis enheden bliver beskadiget, skal du kompensere Lisa& for den opståede skade. Utilsigtede tab- og vandskader dækkes af den medfølgende forsikring, for hvilke der skal oprettes en forsikringssag. Følg instruktionerne i næste trin for at gå videre.</li><li>Hvis din enhed ikke er returneret inden 14 dage efter aftaleperioden er udløbet, skal du betale et gebyr som kompensation for, at enheden ikke er leveret tilbage.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Sådan fungerer det",
                        "steps": [
                            "Klik på opsig tjenesten, og følg vejledningen. Det er muligt at vælge det en måned, inden din aftaleperiode udløber.",
                            "Hvis du har valgt at opsige og returnere (eller ikke valgt noget) vil du modtage et returkit. Kontakt os, hvis du ikke har fået noget, når aftaleperioden er udløbet. Hvis du har valgt at frikøbe din enhed, bliver du faktureret et gebyr på den kommende faktura.",
                            "Slet alle informationer, og fjern din Googlekonto",
                            "Pak din enhed omhyggeligt, og aflever den på nærmeste posthus"
                        ],
                        "action": "Opsig tjenesten",
                        "eligibleNotificationText": "For at annullere din kontrakt i løbet af de første {{days}} dage, kontakt venligst Samsung."
                    }
                },
                "disclaimer": {
                    "flex": {
                        "title": "Husk følgende når du opsiger Samsung Flex, Full Flex:",
                        "content": [
                            "Nulstil din enhed til fabriksindstillinger, slet alle informationer og fjern din Google-konto",
                            "Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved opsigelse",
                            "Hvis enheden er beskadiget stjålet eller forsvundet, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du kun en begrænset selvrisiko.",
                            "Fakturering genoptages for din enhed, hvis den ikke er returneret inden for 14 dage, efter udløbet af den måned hvor du opsagde aftalen."
                        ],
                        "bolttech": {
                            "content": [
                                "Nulstil din enhed til fabriksindstillinger, slet alle informationer og fjern din Google-konto",
                                "Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved opsigelse",
                                "Hvis enheden er beskadiget, stjålet eller forsvundet, skal du kompensere Lisa& for den opståede skade. I Samsung Flex medfølger en forsikringsaftale, som dækker utilsigtede vandskader og ulykkestilfælde. Følg instruktionerne for at afslutte din opsigelse og registre en forsikringssag, hvis du har en sådan skade.",
                                "Fakturering genoptages for din enhed, hvis den ikke er returneret inden for 14 dage, efter udløbet af den måned hvor du opsagde aftalen."
                            ]
                        }
                    },
                    "value": {
                        "title": "Husk følgende, når du opsiger din Samsung Flex 24 måneder:",
                        "content": [
                            "Nulstil din enhed til fabriksindstillinger, slet alle informationer og fjern din Google-konto fra din enhed, inden du sender enheden ind.",
                            "Hvis enheden er beskadiget eller forsvundet, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du kun en begrænset selvrisiko. Læs de fuldstændige vilkår.",
                            "Hvis din enhed ikke er returneret inden for 14 dage, efter at aftaleperioden er udløbet, bliver du faktureret et gebyr for at kompensere Foxway for den ikke tilbageleverede enhed."
                        ],
                        "bolttech": {
                            "content": [
                                "Nulstil din enhed til fabriksindstillinger, slet alle informationer og fjern din Google-konto fra din enhed, inden du sender enheden ind.",
                                "Hvis enheden er beskadiget, stjålet eller forsvundet, skal du kompensere Lisa& for den opståede skade. I Samsung Flex medfølger en forsikringsaftale, som dækker utilsigtede vandskader og ulykkestilfælde. Følg instruktionerne for at afslutte din opsigelse og registre en forsikringssag, hvis du har en sådan skade. ",
                                "Hvis din enhed ikke er returneret inden for 14 dage, efter at aftaleperioden er udløbet, bliver du faktureret et gebyr for at kompensere Foxway for den ikke tilbageleverede enhed."
                            ]
                        }
                    }
                },
                "formTitle": "Vi har brug for flere oplysninger, inden du opsiger",
                "conditionChoice": "Er enheden i god stand?",
                "conditionsButton": "Vis mere",
                "noDamage": "Ja, enheden er i god stand, fungerer og har ingen skader. Normal slitage og kosmetiske skader som fx ridser, der ikke påvirker funktionaliteten, regnes ikke som skade.",
                "noDamageDescription": "",
                "hasDamage": "Nej, enheden er beskadiget, stjålet eller forsvundet.",
                "hasDamageDescription": "",
                "damageTitle": "Beskriv, hvad der er sket med din enhed",
                "damageAdditionalTitle": "Hav billeder af skaden klar (forside, bagside, åben). Du vil blive bedt om at uploade dem herunder.",
                "damageDate": "Hvornår opstod skaden?",
                "damageDatePlaceholder": "Vælg dato",
                "nextMonth": "Næste måned",
                "prevMonth": "Forrige måned",
                "damageDescription": "Beskriv, hvad der er sket med din enhed",
                "damageDescriptionPlaceholder": "Beskriv, hvad der er sket med din enhed",
                "damageSpecTitle": "Vælg den beskrivelse, der passer bedst på skaden. Du kan vælge flere alternativer.",
                "termsLabel": "Jeg har læst og accepterer ovenstående oplysninger",
                "submitButton": "Bekræft",
                "damageType": {
                    "placeholder": "Vælg et alternativ",
                    "fellAndBroke": "Min enhed har en uforsætlig tabs- eller vandskade",
                    "stoppedWorking": "Min enhed er holdt op med at fungere eller har andre tekniske fejl, som er opstået uden påvirkninger",
                    "lostOrStolen": "Min enhed er stjålet eller forsvundet"
                },
                "specificDamage": {
                    "frontScreen": "Skærmskade – hovedskærm",
                    "frontScreenDescription": "Hovedskærmen (den største skærm, hvis enheden har flere skærme) har en eller flere revner (ridser betragtes ikke som skader).",
                    "frontScreenAddFile": "Upload foto",
                    "frontScreenFile": "Skærmskade – hovedskærm",
                    "frontScreenRemove": "Fjern fotos på frontskærmen",
                    "backSide": "Skade på bagsiden og/eller rammen",
                    "backSideDescription": "Bagsiden og/eller rammen er gået i stykker eller bøjet. (ridser betragtes ikke som skader)",
                    "backSideAddFile": "Upload foto",
                    "backSideFile": "Skade på bagsiden og/eller rammen",
                    "backSideRemove": "Fjern billedet på bagsiden",
                    "camera": "Kamera problem",
                    "cameraDescription": "Forreste eller bagerste kamera virker ikke problem med foto/videokvalitet",
                    "audio": "Lydproblem",
                    "audioDescription": "Mikrofonen eller højttaleren virker ikke, lydforvrængning problemer",
                    "network": "Netværksproblem",
                    "networkDescription": "Enheden har problemer med at oprette forbindelse til netværket",
                    "power": "ON/OFF problem",
                    "powerDescription": "Kan ikke tænde eller slukke for enheden",
                    "other": "Andet",
                    "otherDescription": "Enheden har en anden form for skade",
                    "otherDescriptionLabel": "Beskriv venligst skaden i detaljer",
                    "otherDescriptionPlaceholder": "Beskriv skaden"
                },
                "notSupportedNotificationTitle": "Stjålne eller mistede enheder er ikke berettiget til annullering",
                "notSupportedNotificationContent": "Kontakt vores support for mere information.",
                "upsell": {
                    "title": "Er du sikker på, at du vil opsige?",
                    "content": "Hvis du ønsker at udskifte din enhed, findes der andre muligheder.",
                    "options": {
                        "swap-device": "Jeg vil opgradere min enhed",
                        "cancel-sub": "Jeg vil opsige tjenesten",
                        "upgrade-device": "Jeg vil anmelde en skade og fortsætte med at bruge Samsung Flex"
                    },
                    "confirmButton": "Bekræft",
                    "closeButton": "Luk"
                },
                "warrantyNotificationTitle": "Det ser ud til, at dit problem er dækket af garantien",
                "warrantyNotificationContent": "Kontakt vores support for mere information."
            },
            "upgrade": {
                "unavailableNotification": {
                    "title": "Opdateringen er ikke tilgængelig.",
                    "content": "Kontakt vores support for mere information.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "guide": {
                    "FLEX": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Vil du opgradere eller skifte til en ny enhed?",
                        "action": "Opgrader",
                        "url": "https://samsung.com",
                        "content": [
                            "Med Full Flex kan du opgradere eller skifte enhed, når du vil. Vælg din nye enhed på samsung.com, og bestil den med Samsung Flex. I næste trin vælger du at opgradere din eksisterende Samsung Flex-tjeneste. Når du har gennemført bestillingen, indgår du en ny aftale inden for rammerne af Samsung Flex, og du får din nye enhed leveret hjem sammen med en returfragtseddel, som skal bruge til at sende den gamle enhed retur. Derefter kan du overføre alt indhold til den nye enhed, inden du sender den gamle retur. Du bliver faktureret for prisen på den nye enhed fra du modtager den\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto, inden du sender din enhed retur.</li><li>Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved en opgradering, da du indgår en ny aftale. Eventuel opnået rabat for den byttede enhed overføres omvendt til din nye aftale.</li><li>Hvis enheden er beskadiget, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du en begrænset selvrisiko.</li><li> Fakturering genoptages for din nuværende enhed, hvis den ikke er returneret inden for 14 dage, fra du modtog din nye enhed.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Med Full Flex kan du opgradere eller skifte enhed, når du vil. Vælg din nye enhed på samsung.com, og bestil den med Samsung Flex. I næste trin vælger du at opgradere din eksisterende Samsung Flex-tjeneste. Når du har gennemført bestillingen, indgår du en ny aftale inden for rammerne af Samsung Flex, og du får din nye enhed leveret hjem sammen med en returfragtseddel, som skal bruge til at sende den gamle enhed retur. Derefter kan du overføre alt indhold til den nye enhed, inden du sender den gamle retur. Du bliver faktureret for prisen på den nye enhed fra du modtager den\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto, inden du sender din enhed retur.</li><li>Ubrugte rabatter i din nuværende Samsung Flex-aftale ophører ved en opgradering, da du indgår en ny aftale. Eventuel opnået rabat for den byttede enhed overføres omvendt til din nye aftale.</li><li>Enheden skal leveres tilbage i god stand - normal slitage er ok. Hvis enheden bliver beskadiget, skal du kompensere Lisa& for den opståede skade. Utilsigtede tab- og vandskader dækkes af den medfølgende forsikring, for hvilke der skal oprettes en forsikringssag. Gældende for andre skader kan Samsungs garanti benyttes.</li><li>Fakturering genoptages for din nuværende enhed, hvis den ikke er returneret inden for 14 dage, fra du modtog din nye enhed.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Sådan opgraderer du trin for trin",
                        "steps": [
                            "Klik på ”Opgrader”, og vælg din nye enhed på samsung.com.",
                            "Tilføj Samsung Flex og gå til kassen. Vælg vilkår for Samsung Flex, der gælder for din nye enhed.",
                            "Når du identificerer dig, bliver du som eksisterende kunde spurgt, om du vil opgradere din nuværende enhed. Vælg den enhed du vil opgradere.",
                            "Afslut bestillingen, og få din nye enhed leveret hjem sammen med en returfragtseddel til den gamle enhed.",
                            "Overfør alt indhold til den nye enhed. Slet derefter alle informationer, og fjern din Google-konto på den gamle enhed.",
                            "Pak den gamle enhed omhyggeligt, og aflever den på nærmeste posthus. Du kan bruge samme pakke, som du modtog din nye enhed i."
                        ]
                    },
                    "VALUE": {
                        "image": "https://dcosix8as1189.cloudfront.net/imagestorage/VendorImages/Upgrade_section_header.png",
                        "title": "Vil du opgradere til en ny enhed?",
                        "action": "Opgrader",
                        "url": "https://samsung.com",
                        "content": [
                            "Er det tid at opgradere? Med 24 måneder kan du opgradere til en ny enhed, når aftaleperioden udløber. Det gør du ved at vælge din nye enhed på samsung.com, og bestille den med Samsung Flex. I næste trin vælger du at opgradere din eksisterende Samsung Flex-tjeneste. Det kan du gøre fra og med det tidspunkt, hvor der er en måned tilbage af aftaleperioden.\nNår du har gennemført bestillingen, får du din nye enhed leveret hjem sammen med en returfragtseddel, som skal bruges til at sende den gamle enhed tilbage. Så kan du overføre alt indhold til den nye enhed, inden du sender den gamle tilbage.\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto</li><li> Hvis enheden er beskadiget, skal du betale Foxway erstatning for skaden. Ved uforsætlige tabs- og vandskader betaler du kun et begrænset skadegebyr.</li><li> Hvis din enhed ikke er returneret inden for 14 dage, efter at aftaleperioden er udløbet, bliver du faktureret et gebyr for at kompensere Foxway for den ikke tilbageleverede enhed.</li></ul>"
                        ],
                        "bolttech": {
                            "content": [
                                "Er det tid at opgradere? Med 24 måneder kan du opgradere til en ny enhed, når aftaleperioden udløber. Det gør du ved at vælge din nye enhed på samsung.com, og bestille den med Samsung Flex. I næste trin vælger du at opgradere din eksisterende Samsung Flex-tjeneste. Det kan du gøre fra og med det tidspunkt, hvor der er en måned tilbage af aftaleperioden.\nNår du har gennemført bestillingen, får du din nye enhed leveret hjem sammen med en returfragtseddel, som skal bruges til at sende den gamle enhed tilbage. Så kan du overføre alt indhold til den nye enhed, inden du sender den gamle tilbage.\n\nHusk:\n<ul><li>At nulstille din enhed til fabriksindstillinger, slette alle informationer og fjerne din Google-konto</li><li>Enheden skal leveres tilbage i god stand - normal slitage er ok. Hvis enheden bliver beskadiget, skal du kompensere Lisa& for den opståede skade. Utilsigtede tab- og vandskader dækkes af den medfølgende forsikring, for hvilke der skal oprettes en forsikringssag. Gældende for andre skader kan Samsungs garanti benyttes.</li><li> Hvis din enhed ikke er returneret inden for 14 dage, efter at aftaleperioden er udløbet, bliver du faktureret et gebyr for at kompensere Foxway for den ikke tilbageleverede enhed.</li></ul>"
                            ]
                        },
                        "stepsTitle": "Sådan opgraderer du trin for trin",
                        "steps": [
                            "Kontroller din aftaleperiode. Med 24 måneder kan du bestille en opgradering en måned før aftaleperioden udløber.",
                            "Klik på 'Opgrader', og vælg din nye enhed på samsung.com.",
                            "Når du identificerer dig, bliver du som eksisterende kunde spurgt, om du vil opgradere din nuværende enhed. Vælg den enhed, du vil opgradere.",
                            "Afslut bestillingen, og få din nye enhed leveret hjem sammen med en returfragtseddel til den gamle enhed.",
                            "Overfør alt indhold til den nye enhed. Slet derefter alle informationer, og fjern din Google-konto på den gamle enhed.",
                            "Pak den gamle enhed omhyggeligt, og aflever den på nærmeste posthus. Du kan bruge samme pakke, som du modtog din nye enhed i."
                        ]
                    }
                }
            },
            "swap": {
                "unavailableNotification": {
                    "title": "Swap Service er ikke tilgængelig.",
                    "content": "Kontakt vores support for mere information.",
                    "linkText": "",
                    "linkUrl": ""
                },
                "receipt": {
                    "title": "Swap service med sags-id {{id}} er registreret",
                    "content": "Når din sag er behandlet, og hvis den er godkendt, vil du modtage en faktura med bytteprisen. (Hvis du har direkte debitering aktiveret, vil omkostningerne automatisk blive trukket fra din konto). Så snart betalingen er foretaget, vil en erstatningsenhed blive sendt til dig sammen med et returneringssæt, som du bruger til at sende din beskadigede enhed tilbage til Foxway.",
                    "button": "Tilbage Hjem"
                },
                "paymentSuccess": {
                    "title": "Swap Service-sag {{id}} er nu oprettet og betalt",
                    "content": "Du kan se dine igangværende Swap Service-opgaver og deres status under <1>Mine Enheder</1><2>Din opgave vil blive behandlet inden for 2 arbejdsdager.</2>",
                    "button": "Tilbage Hjem"
                },
                "paymentError": {
                    "title": "Swap Service-sag {{id}} er nu oprettet men betalingen mislykkedes",
                    "content": "Gennemføre betalingen for at fuldføre din Swap Service",
                    "button": "Betale"
                },
                "title": "Swap Service",
                "bolttech": {
                    "title": "Opret forsikringssag",
                    "deviceDamagedConditionTerms": "<0>Hvis enheden bliver beskadiget eller du mister den, skal du kompensere Lisa& for den opståede skade. Forsikringsaftalen Samsung Care+ følger med i Samsung Flex og dækker utilsigtede tab- og vandskader, for hvilke der skal oprettes en forsikringssag. Gældende for andre skader kan Samsungs garanti benyttes.</0><1>Udfyld formularen for at få hjælp til at afklare, hvordan dit problem bliver løst bedst muligt.</1>",
                    "submitButton": "Fortsæt",
                    "continueButton": "Fortsæt",
                    "fellAndBrokeNotificationTitle": "Din type skade dækkes normalt af Samsung Care+.",
                    "fellAndBrokeNotificationContent": "Fortsæt for at oprette en forsikringssag hos forsikringsselskabet.",
                    "stoppedWorkingNotificationTitle": "Dit problem dækkes ikke af forsikringen, men er omfattet af garantien.",
                    "stoppedWorkingNotificationContent": "Kontakt vores support for mere information.",
                    "lostOrStolenNotificationTitle": "Hvis du har mistet din telefon, dækker forsikringen ikke.",
                    "lostOrStolenNotificationContent": "Kontakt vores support for mere information."
                },
                "claimStatus": {
                    "pending": "Swap Service under gennemgang",
                    "approved": "Ny enhed sendt",
                    "declined": "Swap Service afvist",
                    "completed": "Afsluttet",
                    "sent": "Retursæt sendt",
                    "waitingForPayment": "Har udestående fakturaer",
                    "paymentReceived": "Betaling modtaget",
                    "deviceReceived": "Enhed modtaget",
                    "deviceReceivedDamaged": "Enhed modtaget beskadiget"
                },
                "formTitle": "Beskriv din sag",
                "submitButton": "Registrering og betaling",
                "registerButton": "Registrer sag",
                "payButton": "Betale",
                "continueButton": "Fortsæt",
                "damageTitle": "Beskriv, hvad der er sket med din enhed",
                "damageAdditionalTitle": "Hav billeder af skaden klar (forside, bagside, åben). Du vil blive bedt om at uploade dem herunder.",
                "damageDate": "Hvornår opstod skaden?",
                "damageDatePlaceholder": "Vælg dato",
                "nextMonth": "Næste måned",
                "prevMonth": "Forrige måned",
                "damageDescription": "Beskriv, hvad der er sket med din enhed",
                "damageDescriptionPlaceholder": "Beskriv, hvad der er sket med din enhed",
                "damageSpecTitle": "Vælg den beskrivelse, der passer bedst på skaden. Du kan vælge flere alternativer.",
                "termsLabel": "Jeg har læst og accepterer ovenstående oplysninger",
                "summaryTitle": "Ansøgning om Swap service",
                "summary": {
                    "overview": {
                        "issues": {
                            "fell-and-broke": "Min enhed har en uforsætlig tabs- eller vandskade",
                            "lost": "Enhed mistet eller stjålet"
                        }
                    },
                    "returnKitSentNotificationTitle": "Bemærk venligst",
                    "returnKitSentNotificationContent": "Vi sender dig et retursæt for at hjælpe dig med at returnere enheden.",
                    "returnKitSentNotificationLink": "#",
                    "returnKitSentNotificationLinkText": "",
                    "accordionTitle": "Ansøgning om Swap service",
                    "certificateTitle": "Sag-id",
                    "productTitle": "Produkt",
                    "customerTitle": "Kundens navn",
                    "periodTitle": "Startdato for abonnement",
                    "deviceDetailsTitle": "Enhedsdetaljer",
                    "overviewTitle": "Sagsoversigt",
                    "overviewIssueTitle": "Skadetype",
                    "overviewDamageDescriptionTitle": "Beskrivelse",
                    "overviewDateTitle": "Skadedato",
                    "overviewDamagesTitle": "Skader",
                    "front-side": "Skærmskade – hovedskærm",
                    "back-side": "Skade på bagsiden og/eller rammen",
                    "camera": "Beskadiget kamera",
                    "audio": "Lydproblemer",
                    "network": "Netværksproblemer",
                    "on-off-problem": "ON/OFF problemer",
                    "other": "Andet"
                },
                "notSupportedNotificationTitle": "Tab af enhed er ikke dæket av Swap Service, prisen vil variere, afhægigt af enhed.",
                "notSupportedNotificationContent": "Registrer mistet enhed for at modtage et tilbud fra Foxway om erstatningsenhed.",
                "warrantyNotificationTitle": "Det ser ud til, at dit problem er dækket af garantien",
                "warrantyNotificationContent": "Kontakt vores support for mere information."
            }
        },
        "privacyPolicy": {
            "title": "Cookie- og databeskyttelsespolitik",
            "sections": [
                {
                    "title": "1. Brug af cookies og databehandling",
                    "content": "Foxway og dets partnere, inklusive vores finansielle partner Lisa& Friends AB (registreret i Sverige under virksomhedsnummer 934431650, med registreret adresse på c/o United Spaces, Drottninggatan 32, 111 51 Stockholm, Sverige), bruger cookies og lignende teknologier (\"Teknologier\") til at gemme og få adgang til information på din enhed.\n\nDisse teknologier er essentielle for at levere sikre og funktionelle tjenester, inklusive betalingsprocesser og kundeportal-funktionaliteter. Ved at acceptere cookies giver du samtykke til behandlingen af dine data, inklusive deling af relevante oplysninger med Lisa& Friends AB for at lette finansielle tjenester og sikre en problemfri oplevelse. Du kan finde flere detaljer om vores datadeling-praksis i vores <a href=\"https://www.foxway.com/en/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">privatlivspolitik</a>."
                },
                {
                    "title": "2. Typer af cookies vi bruger",
                    "content": "Vi bruger både essentielle og valgfrie cookies for at forbedre din oplevelse. Disse inkluderer:",
                    "items": [
                        "Strengt nødvendige cookies – Krævet for kernefunktionalitet på websitet, inklusive sikkerhed og tilgængelighed.",
                        "Performance- og analyse-cookies – Hjælper os med at analysere, hvordan vores website bruges for at forbedre brugervenlighed og ydeevne.",
                        "Marketing- og reklame-cookies – Muliggør personlige annoncer og marketingkampagner, inklusive på tredjepartsplatforme."
                    ]
                },
                {
                    "title": "3. Administrer dine cookie-præferencer",
                    "content": "Du kan administrere dine cookie-præferencer når som helst:",
                    "items": [
                        "Accepter alle cookies – Aktiverer fuld funktionalitet, inklusive personligt indhold og marketing.",
                        "Afvis ikke-essentielle cookies – Tillader kun strengt nødvendige cookies.",
                        "Tilpas indstillinger – Juster specifikke cookie-præferencer baseret på kategorier."
                    ],
                    "footer": "Du kan ændre dine samtykkeindstillinger når som helst ved at klikke på \"Tilpas cookies\" nederst på vores website.\n\nFor mere information om, hvordan Foxway behandler dine data, bedes du gennemgå vores <a href=\"https://www.foxway.com/en/privacy-policy/\" target=\"_blank\" rel=\"noopener noreferrer\">privatlivspolitik</a>."
                }
            ]
        },
        "sessionExpires": {
            "title": "Sessionen er udløbet",
            "description": "Vil du fortsætte sessionen?",
            "continueButtonText": "Fortsætte",
            "cancelButtonText": "Log ud nu"
        }
    }
}
